/**MTNContext.js — MTN Nigeria SSOT Context */
import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import client from "@/api/client";
const Ctx = createContext(null);
export const useMTN = () => useContext(Ctx);
export function MTNProvider({ children }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedPeriod, setSelectedPeriod] = useState("MTN-2026-FY");
  const [periods, setPeriods] = useState([{period_id:"MTN-2026-FY",label:"FY 2025/2026 (Baseline)"}]);
  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const [dashR, perR] = await Promise.all([
        client.get(`/mtn/dashboard?period_id=${selectedPeriod}`),
        client.get("/mtn/periods"),
      ]);
      setData(dashR.data);
      if (perR.data?.periods?.length > 0) setPeriods(perR.data.periods);
    } catch(e) { console.error("MTNContext load failed:", e); }
    finally { setLoading(false); }
  }, [selectedPeriod]);
  useEffect(() => { reload(); }, [selectedPeriod]);
  const group = data?.group || {};
  const businessUnits = data?.business_units || [];
  const projects = data?.projects || {};
  const insights = data?.insights || [];
  return (
    <Ctx.Provider value={{ data, loading, reload, selectedPeriod, setSelectedPeriod, periods, group, businessUnits, projects, insights }}>
      {children}
    </Ctx.Provider>
  );
}
